import './SpinnerOverlay.css';

/**
 * Full-screen blocking loader: a light blurred wash over the page with a centered
 * card holding the Violerts signal-arcs spinner, the message and an optional second line.
 *
 * @param {string} text Main message, e.g. "Checking out..."
 * @param {string} subtext Optional smaller line under the message
 * @param {boolean} isLoading Renders nothing when false
 */
function SpinnerOverlay({ text, subtext, isLoading }) {
	if (!isLoading) {
		return null;
	}

	return (
		<div className="spinner-overlay" role="status" aria-live="polite" aria-busy="true">
			<div className="spinner-overlay-card">
				{/* Violerts signal-arcs spinner, same icon as the inline Spinner. Served from
					public/ as an <img> so its internal CSS animation isn't stripped by the
					build; it carries its own reduced-motion fallback. */}
				<img
					className="spinner-overlay-spinner"
					src="/violerts-spinner.svg"
					alt=""
					aria-hidden="true"
				/>
				<div className="spinner-overlay-text">{text || 'Loading...'}</div>
				{subtext && <div className="spinner-overlay-subtext">{subtext}</div>}
			</div>
		</div>
	);
}

export default SpinnerOverlay;
